import _ from 'lodash';
import localStorageUtils, { STORAGE_KEYS } from './localStorageUtils';

export const DEFAULT_WORKSPACE = 'prod';

export default class WorkspaceUtils {
  static getDefaultWorkspace() {
    return DEFAULT_WORKSPACE;
  }

  static isProdWorkspace(workspace) {
    return !!workspace && DEFAULT_WORKSPACE === workspace;
  }

  static selectedWorkspaceFromLocalStorage() {
    const workspace = localStorageUtils.getItem(STORAGE_KEYS.MOST_RECENTLY_VIEWED_WORKSPACE);
    return workspace === null ? false : workspace;
  }

  static setWorkspaceForLocalStorage(workspace) {
    localStorageUtils.setItem(STORAGE_KEYS.MOST_RECENTLY_VIEWED_WORKSPACE, workspace);
  }

  static addWorkspaceToRecent(workspace) {
    const pastRecentWorkspaces = this.getRecentWorkspaces();
    pastRecentWorkspaces.unshift(workspace);
    const deDupedWorkspaces = [...new Set(pastRecentWorkspaces)].slice(0, 10);
    localStorageUtils.setJSON(STORAGE_KEYS.RECENT_WORKSPACES, deDupedWorkspaces);
  }

  static getRecentWorkspaces() {
    return localStorageUtils.getJSON(STORAGE_KEYS.RECENT_WORKSPACES, []);
  }

  static getWorkspaceFromStore() {
    // Get workspace from localStorage instead of Redux store
    return WorkspaceUtils.selectedWorkspaceFromLocalStorage();
  }

  static isValidWorkspace(workspace) {
    const regexp = '^[a-zA-Z0-9-_]+$';
    return workspace && workspace.search(regexp) !== -1;
  }

  static isDevelopmentWorkspace(listOfWorkspaces, workspace) {
    const matchWorkspace = _.filter(listOfWorkspaces.data.workspaces, (space) => {
      return space.name === workspace;
    });

    if (matchWorkspace.length == 0) {
      return false;
    }
    if (matchWorkspace[0].hasOwnProperty('capabilities') === false) {
      return false;
    }
    if (matchWorkspace[0].capabilities.hasOwnProperty('materializable') == false) {
      return false;
    }

    return matchWorkspace[0].capabilities.materializable;
  }
}
